<div class="grid-wrapper">
    <div class="grid-totals-row-1-col-1">
        <div class="mat-elevation-z3 " style="padding: 16px; height: 310px;">
            <h2>{{transport.TransportTypeName}}
                <dx-button style="float:right"
                    icon="save"
                    (onClick)="onSaveHeader($event)"
                    [disabled]="isEditingDisabled || !transport?.PrimaryProjectId || transport?.PrimaryProjectId === -1 || ((!transport?.SecondaryProjectId || transport?.SecondaryProjectId === -1) && !isNewTransport)">
                </dx-button>
            </h2>
            <div class="grid-totals-wrapper" >
                <div *ngIf="!isNewTransport" class="grid-row-1-col-1">
                    <strong>{{lblNoOfTrips}}</strong>
                </div>
                <div *ngIf="!isNewTransport" class="grid-row-1-col-2">
                    {{transport.NoOfTrips}}
                </div>
                <div class="grid-row-1-col-5 " style="text-align: right;">
                </div>
                <div class="grid-row-2-col-1">
                    <strong>{{this.languageService.LNG("Label.Date")}}</strong>
                </div>
                <div class="grid-row-2-col-2 ">
                    <dx-date-box [(value)]="transport.Date" type="date" displayFormat="dd.MM.yyyy" [readOnly]="isEditingDisabled"></dx-date-box>
                </div>
                <div class="grid-row-2-col-4 ">
                    <strong>{{this.languageService.LNG("Label.Employee")}}</strong>
                </div>
                <div class="grid-row-2-col-5 ">
                    <dx-select-box
                      [dataSource]="{store: employees, paginate: true, pageSize: 10}"
                      displayExpr="EmployeeNumberAndName"
                      searchExpr="EmployeeNumberAndName"
                      valueExpr="EmployeeId"
                      [searchEnabled]="true"
                      [showClearButton]="true"
                      [(value)]="transport.EmployeeId"
                      [readOnly]="isEditingDisabled">
                    </dx-select-box>
                </div>
                <div class="grid-row-3-col-1">
                    <strong>{{this.languageService.LNG("Label.FromProject")}} *</strong>
                </div>
                <div class="grid-row-3-col-2 ">
                    <dx-box direction="row"
                      width="100%">
                      <dxi-item  [ratio]="5">
                            <dx-select-box
                                [dataSource]="projects"
                                displayExpr="ProjectDisplayName"
                                searchExpr="ProjectDisplayName"
                                valueExpr="ProjectId"
                                [searchEnabled]="true"
                                [showClearButton]="true"
                                [placeholder]="placeholderProjectSelectSearch"
                                [(value)]="transport.SecondaryProjectId"
                                (onFocusIn)="focusProject($event)"
                                [readOnly]="isEditingDisabled">
                            </dx-select-box>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <dx-button style="margin-left: 2px; margin-right: 2px" icon="search" [height]="35" (onClick)="showPopupProject(transport.SecondaryProjectId, false)" [disabled]="isEditingDisabled"></dx-button>
                        </dxi-item>
                    </dx-box>
                </div>
                <div class="grid-row-3-col-4">
                    <strong>{{this.languageService.LNG("Label.ToProject")}} *</strong>
                </div>
                <div class="grid-row-3-col-5">
                    <dx-box direction="row"
                      width="100%">
                      <dxi-item  [ratio]="5">
                            <dx-select-box
                                [dataSource]="projects"
                                displayExpr="ProjectDisplayName"
                                searchExpr="ProjectDisplayName"
                                valueExpr="ProjectId"
                                [searchEnabled]="true"
                                [showClearButton]="true"
                                [placeholder]="placeholderProjectSelectSearch"
                                [(value)]="transport.PrimaryProjectId"
                                (onFocusIn)="focusProject($event)"
                                [readOnly]="isEditingDisabled">
                            </dx-select-box>
                        </dxi-item>
                        <dxi-item [ratio]="1">
                            <dx-button style="margin-left: 2px; margin-right: 2px" icon="search" [height]="35" (onClick)="showPopupProject(transport.PrimaryProjectId, true)" [disabled]="isEditingDisabled"></dx-button>
                        </dxi-item>
                    </dx-box>
                </div>
                <div class="grid-row-4-col-1">
                   <strong>{{this.languageService.LNG("Label.Customref")}}</strong>
                </div>
                <div class="grid-row-4-col-2 ">
                    <dx-text-box  [(value)]="transport.CustomerReference" [readOnly]="isEditingDisabled"></dx-text-box>
                </div>
                <div class="grid-row-4-col-4">
                    <strong >{{this.languageService.LNG("Label.Comment")}}</strong>
                </div>
                <div class="grid-row-4-col-5 ">
                    <dx-text-area [(value)]="transport.Comment" [readOnly]="isEditingDisabled"></dx-text-area>
                </div>
            </div>
        </div>
    </div>

    <div  class="grid-weekoverview-row-1-col-5">
    </div>

    <div class="grid-row-2-col-1" [class.not-available]="isNewTransport || transport.Times.length <= 0">
      <app-edit-transport-addition [transport]="transport" [gridDataSource]="transport.TransportAdditions" (loading)="onLoading($event)" [newStatusId]="3" [newCategoryId]="8" (changed)="refreshIsRquired = true"></app-edit-transport-addition>
    </div>

    <div class="grid-equipment-row-2-col-2" [class.not-available]="isNewTransport || transport.Times.length <= 0">
      <app-edit-transport-equipment #transportEquipment [transport]="transport" [gridDataSource]="transport.TransportEquipment" (loading)="onLoading($event)" (changed)="refreshIsRquired = true"></app-edit-transport-equipment>
    </div>

    <div class="grid-expense-row-3-col-1" [class.not-available]="isNewTransport || transport.Times.length <= 0">
      <app-edit-transport-expense [transport]="transport" [gridDataSource]="transport.TransportExpenses" (loading)="onLoading($event)" [newStatusId]="3" [newCategoryId]="8" (changed)="refreshIsRquired = true"></app-edit-transport-expense>
    </div>

    <div class="grid-articles-row-3-col-2" [class.not-available]="isNewTransport || transport.Times.length <= 0">
      <app-edit-transport-transportarticle [transport]="transport" [gridDataSource]="transport.TransportArticles" (loading)="onLoading($event)" (changed)="refreshIsRquired = true"></app-edit-transport-transportarticle>
    </div>

    <div class="grid-log-col-5">
        <div class="grid-log-wrapper">
            <div class="grid-row-1-col-1" [class.not-available]="isNewTransport">
                <app-edit-transport-time [transport]="transport" [gridDataSource]="transport.Times" (loading)="onLoading($event)" [newStatusId]="3" [newCategoryId]="8" (changed)="refreshIsRquired = true; transportEquipment.refresh()"></app-edit-transport-time>
            </div>
            <div class="grid-row-2-col-1" [hidden]="isNewTransport">
                <app-edit-transport-logtimes [minusHeight]="650" [gridDataSource]="transport.TimeLog" [date]="transport.Date" ></app-edit-transport-logtimes>
            </div>
        </div>
    </div>
</div>

<dx-popup
  class="popup"
  [width]="350"
  [height]="300"
  [showTitle]="true"
  title="Project"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="popupVisibleProjectSearch">
  <div *dxTemplate="let data of 'content'">
      <p>
        Customer:
        <dx-select-box [dataSource]="customerPopupDataSource"
          displayExpr="Name"
          valueExpr="CustomerId"
          [searchEnabled]="true"
          (onValueChanged)="onPopupCustomerChanged($event)"
          [value]="selectedCustomerIdPopup"
          [showClearButton]="true">
        </dx-select-box>
      </p>
      <p>
        Project:
        <dx-select-box [dataSource]="projectsPopupDataSource"
          displayExpr="ProjectDisplayName"
          searchExpr="ProjectDisplayName"
          valueExpr="ProjectId"
          [searchEnabled]="true"
          (onSelectionChanged)="onPopupProjectChanged($event)"
          [placeholder]="placeholderProjectSelectSearch"
          [value]="selectedProjectIdPopup"
          [showClearButton]="true">
        </dx-select-box>
      </p>
      <p>
        <dx-button text="Ok" (onClick)="onClickPopupSelectedProject($event)">

        </dx-button>
      </p>
  </div>
</dx-popup>
<app-spinner [isVisible]="isLoadIndicatorVisible"></app-spinner>
